import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<User | null>(null);
  public user$ = this.userSubject.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor() {}

  setUser(user: User | null): void {
    this.userSubject.next(user);
  }

  getUser(): User | null {
    return this.userSubject.value;
  }

  clearUser(): void {
    this.userSubject.next(null);
  }

  setLoading(loading: boolean): void {
    this.loadingSubject.next(loading);
  }

  isLoading(): boolean {
    return this.loadingSubject.value;
  }

  // Helper methods for user display
  getDisplayName(): string {
    const user = this.getUser();
    return user?.displayName || user?.name || 'User';
  }

  getAvatar(): string | null {
    const user = this.getUser();
    return user?.avatar || user?.image || null;
  }

  getConnectedServices(): string[] {
    const user = this.getUser();
    if (!user) return [];

    const services: string[] = [];
    if (user.spotifyConnected) services.push('spotify');
    if (user.discogsConnected) services.push('discogs');
    if (user.facebookConnected) services.push('facebook');
    if (user.googleConnected) services.push('google');

    return services;
  }
}
